import { bindConnect } from '../../utils';
import UsersSort from './UsersSort';

export default bindConnect(state => ({
  loading: false
}), {
})(UsersSort);
